export default "__VITE_ASSET__CU1FcD35__"